import { render } from "./UnscheduledTasksListItem.vue?vue&type=template&id=23cdbe77"
import script from "./UnscheduledTasksListItem.vue?vue&type=script&lang=js"
export * from "./UnscheduledTasksListItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__